const footerStyle = {color:"gray"}

function Footer() {
    return (<div>
      <p style={footerStyle}> by Scott Nalley </p>
    </div>);
}

export default Footer;
